import Services from '../../services'

const state = {
  coins: []
};

// getters
const getters = {
  coins: (state, getters, root) => {
    return state.coins;
  },
};

// actions
const actions = {
  async fetchCoins({ commit, state, dispatch }) {
    // const data = await Services.Coins.fetchCoins();
    // let coins = data.default.map(e => { e.small = true; return e; })
    // commit('updateCoins', coins);
  },
  smallAllCoins({ commit, state, dispatch }, coin) {
    commit('smallerCoins', coin);
  }
};

// mutations
const mutations = {
  updateCoins(state, data) {
    state.coins = [].concat(data);
  },
  smallerCoins(state, coin) {
    state.coins.forEach(c => {
      if (c != coin) c.small = true;
      else c.small = !c.small;
    })
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/coins.js